import { ids } from "@icarros/theme-react";
import { hexToRgba } from "@icarros/utils-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
import { LabelSizes, LabelVariants, LabelWeights, } from "./constants";
const { text, color, opacity } = ids || {};
const neutral = css `
  color: ${({ isDisabled, isVariant, isError }) => {
    if (isDisabled)
        return color.action.disabled.ids_color_action_disabled_variant;
    if (isVariant)
        return color.action.neutral.ids_color_action_neutral_variant;
    if (isError) {
        return color.feedbacks.ids_color_feedback_error;
    }
    return color.action.neutral.ids_color_action_neutral_base;
}};
`;
const positive = css `
  color: ${color.feedbacks.ids_color_feedback_success};
`;
const negative = css `
  color: ${color.feedbacks.ids_color_feedback_alert};
`;
const primary = css `
  color: ${({ isDisabled, isVariant, isError }) => {
    if (isDisabled)
        return color.action.disabled.ids_color_action_disabled_variant;
    if (isVariant)
        return color.action.primary.ids_color_action_primary_variant;
    if (isError) {
        return color.feedbacks.ids_color_feedback_error;
    }
    return color.action.primary.ids_color_action_primary_base;
}};
`;
const secondary = css `
  color: ${color.action.secondary.ids_color_action_secondary_base};
  color: ${({ isDisabled, isVariant, isError }) => {
    if (isDisabled)
        return color.action.disabled.ids_color_action_disabled_variant;
    if (isVariant)
        return color.action.secondary.ids_color_action_secondary_variant;
    if (isError) {
        return color.feedbacks.ids_color_feedback_error;
    }
    return color.action.secondary.ids_color_action_secondary_base;
}};
`;
const onLight = css `
  color: ${({ isDisabled, isVariant }) => {
    if (isDisabled)
        return hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_medium);
    if (isVariant)
        return hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_strong);
    return color.contrast.ids_color_contrast_onLight;
}};
`;
const onDark = css `
  color: ${({ isDisabled, isVariant }) => {
    if (isDisabled)
        return hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium);
    if (isVariant)
        return hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_strong);
    return color.contrast.ids_color_contrast_onDark;
}};
`;
const getLabelLabelSizestyle = (size, weight) => {
    if (weight === LabelWeights.bold) {
        switch (size) {
            case LabelSizes.xlarge:
                return text.label.ids_textStyle_label_xlarge_bold;
            case LabelSizes.large:
                return text.label.ids_textStyle_label_large_bold;
            case LabelSizes.medium:
                return text.label.ids_textStyle_label_medium_bold;
            case LabelSizes.small:
                return text.label.ids_textStyle_label_small_bold;
            case LabelSizes.xsmall:
                return text.label.ids_textStyle_label_xsmall_bold;
            default:
                return text.label.ids_textStyle_label_medium_bold;
        }
    }
    switch (size) {
        case LabelSizes.xlarge:
            return text.label.ids_textStyle_label_xlarge_regular;
        case LabelSizes.large:
            return text.label.ids_textStyle_label_large_regular;
        case LabelSizes.medium:
            return text.label.ids_textStyle_label_medium_regular;
        case LabelSizes.small:
            return text.label.ids_textStyle_label_small_regular;
        case LabelSizes.xsmall:
            return text.label.ids_textStyle_label_xsmall_regular;
        default:
            return text.label.ids_textStyle_label_medium_regular;
    }
};
const getLabelColor = (variant, contrast) => {
    if (contrast && contrast !== Contrast.default)
        return getLabelContrastStyle(contrast);
    return getLabelLabelVariantstyle(variant);
};
const getLabelLabelVariantstyle = (variant) => {
    switch (variant) {
        case LabelVariants.neutral:
            return neutral;
        case LabelVariants.positive:
            return positive;
        case LabelVariants.negative:
            return negative;
        case LabelVariants.primary:
            return primary;
        case LabelVariants.secondary:
            return secondary;
        default:
            return primary;
    }
};
const getLabelContrastStyle = (contrast) => {
    switch (contrast) {
        case Contrast.light:
            return onLight;
        case Contrast.dark:
            return onDark;
    }
    return;
};
const StyledLabel = styled.span `
  ${({ size, weight }) => getLabelLabelSizestyle(size, weight)}
  ${({ variant, contrast }) => getLabelColor(variant, contrast)}
`;
export default StyledLabel;
//# sourceMappingURL=Label.style.js.map